import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import { extendBannerContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { useBanner } from "../../../contexts/banner.js";
import { useBannerStylesheet } from "../../../hooks/banner/useBannerStylesheet.js";
import { useCommonFooterLinks } from "../../../hooks/common/useFooterLinks.js";
import { FooterLink } from "../../common/footer/link.js";
import { LanguageSwitcher } from "../../common/languageSwitcher.js";
const BannerFooter = /*#__PURE__*/ forwardRef((_, ref)=>{
    const { FooterContainer } = useBannerStylesheet().extend(...extendBannerContentStylesheet);
    const banner = useBanner();
    const { isTcf, layout: { type }, footerDesign: { languageSwitcher: languageSwitcherChoice }, individualPrivacyOpen, onClose, i18n: { tcf }, isConsentRecord, languageSwitcher, set } = banner;
    const handleClose = useCallback((e)=>{
        onClose();
        e.preventDefault();
    }, [
        onClose
    ]);
    const { rows: links, render: renderLinks } = useCommonFooterLinks({
        onClose: isConsentRecord ? handleClose : undefined,
        putPoweredByLinkInRow: type === "banner" ? 0 : 1,
        row1: [
            process.env.IS_TCF === "1" && isTcf && !individualPrivacyOpen && /*#__PURE__*/ _jsx(FooterLink, {
                href: "#",
                onClick: ()=>set({
                        individualPrivacyOpen: true
                    }),
                children: tcf.vendorList
            }, "vendorList")
        ],
        row1End: [
            languageSwitcher?.length > 0 && languageSwitcherChoice && languageSwitcherChoice !== "disabled" && /*#__PURE__*/ _jsx(LanguageSwitcher, {}, "languageSwitcher")
        ]
    });
    return /*#__PURE__*/ _jsx(FooterContainer, {
        ref: ref,
        children: /*#__PURE__*/ _jsx("div", {
            children: renderLinks(links)
        })
    });
});
export { BannerFooter };
